//GRID ORIENTED AUTOCOMPLETE - Includes some grid specific values and is capable of handling a nested relationship!
import React, { useState, useEffect, useContext, useRef, useCallback } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { styled } from '@mui/material/styles';
import debounce from 'lodash/debounce';
import axios from "axios";
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { v4 as uuidv4 } from 'uuid';


var dbendpoint = process.env.REACT_APP_DB_API4;

//Default Axios Post Options
const defaultpostoptions = {
	withCredentials: true,
	withXSRFToken: true,
	crossDomain: true,
	mode: "no-cors",
	timeout: 12000 //12 seconds
};

const CssTextField = styled(TextField)({
	'.MuiInputBase-root': {
		"& input": {
			"&::placeholder": { 
				//color:"blue"
				color: "#000",
				opacity: 1 //THIS IS WHAT MAKES IT LOOK GRAY IF IT'S LESS THAN 1.
			},
			//color:"red" //THIS CAN WORK
		},
		padding: "0px 0px 0px 8px",
		height:"100%",
		borderColor: '#FFF!important',
		'&:before': {
			borderColor: '#FFF', //THIS WORKS
		},
		'&:hover:before': {
			/* Removes default input dark bottom border */
			borderBottom: "0px solid #8eb7e7!important", //THIS WORKS, but there may be a hover on... input?
			padding: "0px 0px 0px 8px",
		},

		'&:hover': {
			/* Removes default input dark bottom border */
			borderBottom: "0px solid red!important", //Remove border on hover?
			padding: "0px 0px 0px 8px",
		},
	},
	'& .MuiAutocomplete-root': {
		padding: "0px 0px 0px 8px",
	},
	'& .MuiInput-input': {
		'&:hover:before': {
			/* Removes default input dark bottom border */
			borderBottom: "0px solid #8eb7e7", //THIS WORKS, but there may be a hover on... input?
			padding: "0px 0px 0px 8px",
		},
		fontSize: "14px",
		padding: "0px!important", //THIS WORKS
		borderColor: '#EEE!important',
		'&:hover': {
			borderColor: '#EEE!important',
		},
	},
	// '& label.Mui-focused': {
	//   color: '#A0AAB4',
	// },
	'& .MuiInput-underline': {
		'&:hover:before': {
			/* Removes default input dark bottom border */
			borderBottom: "0px solid #8eb7e7",
		},
	},
	'& .MuiInput-underline:after': {
		//borderBottomColor: '#8eb7e7',  //THIS WORKS
		borderBottom: "0px solid #8eb7e7",
		fontSize: "14px",
	},
	'& .MuiOutlinedInput-root': {
		'&:hover fieldset': {
			borderColor: '#EEE', //THIS WORKS
		},
	},
});


const FlexiGridAutoComplete = ({column, localstate, index, UpdateState, rowRefs, onChangeAutoCompleteValue}) => {
	//These control dropdowns and option controls.
	const [openoptions, openOptions] = React.useState(false);
	const [itemoptions, setItemOptions] = React.useState([{
		key:uuidv4(),
		[column.optionkey]:uuidv4(),
		[column.searchby]:"test"
	}]);
	const [loadingitemoptions, setLoadingItemOptions] = useState(false);


	const [inputValue, setInputValue] = useState((
		//Check for child relationship
		column.childrelationship ? 
		//Check that child relationship has a value, if not, use blank
		(localstate.griditems[index][column.nestedmodel] ? localstate.griditems[index][column.nestedmodel][column.searchby] : "") : 
		(localstate.griditems[index][column.field] ? localstate.griditems[index][column.field] :
			//NO VALUE FOUND, SET DEFAULT BLANK VALUE
			""
		)	
	));

	const InitItemOptions = () => {
		if (!column.autocompletestatic){
			if (itemoptions.length === 0) {
				debouncedItemSearch("");
			}
		} else {
			setItemOptions(column.autocompletevalues);
		}
		openOptions(true);
	}

	const onCloseHandler = () => {
		//console.log("Test this prop:"+defaultsearchterm);
		openOptions(false);
	}


	const onChangeAutoCompleteInput = (event, value, reason) =>{
		console.log(reason);
		if (reason === "input") {
			setInputValue(value);
			debouncedItemSearch(value);

		}
	}

	// Memoize the debounced function to prevent it from being recreated on every render
	// This is the search function for auto-complete. It can be as snappy as you like with debouncetime set. Default 1.5s
	const debouncedItemSearch = useCallback(
		debounce((inputValue) => {
			setLoadingItemOptions(true);
			const postdata = {
				searchtype: column.searchtype,
				searchterm: inputValue,
				limit: column.autocompletelimit,
			};
			axios.post(dbendpoint + "/dbautocomplete", postdata, defaultpostoptions).then(res => {
				if (res.status === 200) {
					if (res.data.Status === "login") {
						window.location.reload(false);
					}
					if (res.data.Status === "Success") {
						for (var i=0; i<res.data.items.length; i++){
							//Some of our code counts on a key, but we'd like to keep that something configurable.
							//Make sure a key is set to something!
							res.data.items[i].key = res.data.items[i][column.optionkey];
						}
						console.log(res.data.items);
						setItemOptions(res.data.items);
						openOptions(true);
					}
				} else {
					//Non-200 message from server.
					
				}
				setLoadingItemOptions(false);
			}).catch((error) => {
				
			}
			);
		}, (column.debounce)), // Adjust the debounce delay in configuration
		[]
	);

	const onChangeItemOption = (event, newvalue) => {
		if (newvalue) {
			console.log("^^^^^^^^^^^^^^^^^^^^^^^^^");
			console.log(newvalue);
			setInputValue(newvalue[column.searchby]);
			localstate.griditems[index][column.saveas] = newvalue[column.saveas];

			onChangeAutoCompleteValue(index, column, newvalue);


			// rowRefs.current[index + "SaveStatus"].classList.add(classes.unsavedhighlight);
			// btnSave.current.style.display = "none";
			// btnPendingSave.current.style.display = "";
			// localstate.griditems[index].unsaved = true;
		}
	}


  return (
    <Autocomplete
	//Evaluate if we need to use a child relationship!
	//If we need to use the relationship, we need to see if the relationship has a value!


	//It's possible we don't even need this defaultValue:
		// defaultValue={(column.childrelationship ? (localstate.griditems[index][column.nestedmodel] ? {
		// 	//CHILD RELATIONSHIP, NESTED MODEL EXISTS
		// 	//Name: "Latitude" 
		// 	//ProductID: 30
		// 	key:"I"+index+"AC"+localstate.griditems[index][column.nestedmodel][column.optionkey],
		// 	[column.searchby]:localstate.griditems[index][column.nestedmodel][column.searchby],
		// 	[column.saveas]:localstate.griditems[index][column.nestedmodel][column.saveas]
		// } : {
		// 	//CHILD RELATIONSHIP DOESN'T EXIST (yet), SEE ABOUT SETTING DEFAULT BLANK VALUE?
		// 	key:"I"+index+"AC-Blank",
		// 	[column.searchby]:"", //Name
		// 	[column.saveas]:"" //ProductID
		// }) : 
		// 	//NO CHILD RELATIONSHIP, CHECK FOR NULL VALUE
		// 	(localstate.griditems[index][column.field] ? localstate.griditems[index][column.field] :
		// 		//NO VALUE FOUND, SET DEFAULT BLANK VALUE
		// 		""
		// 	)	
		// )}


		inputValue={inputValue}
		onInputChange={(event, value, reason) => {
			  onChangeAutoCompleteInput(event, value, reason);
		  }}
		  onChange={(event, newValue) => onChangeItemOption(event, newValue)}
		  open={openoptions} 
		  onOpen={() => { InitItemOptions(); }} 
		  onClose={() => onCloseHandler()}
		  getOptionLabel={(option) => {
			// console.log(option);
			// console.log(column.searchby);
			console.log(option[column.searchby]);
			return (
				option[column.searchby]
			)
		  }}
		  options={itemoptions}
		  loading={loadingitemoptions}
		  renderOption={(props, option) => (
			  <ListItem {...props} key={option["key"]}>
				  <ListItemText primary={option[column.searchby]} />
			  </ListItem>
		  )}
		  sx={{ width: 300, height: "100%" }}
		  //renderInput={(params) => <TextField {...params} label="Movie" />}
		  renderInput={(params) => (
			  <div style={{ borderBottom: "0px solid #EEE", verticalAlign:"bottom" }}>
			{/* A regular <input> can't use inputRef or ref at all really. It simply won't work. */}
			<CssTextField
				variant="standard"
				{...params}
				// slotProps={{
				// 	input: {
				// 		value:"mart",
				// 	  endAdornment: column.endadornment,
				// 	},
				// }}
				//TO DO: SET THIS UP FOR PRODUCTNAME
				//placeholder={localstate.griditems[index][column.nestedmodel] ? localstate.griditems[index][column.nestedmodel][column.searchby] : ""}
			/>
		</div>
	)}
    />
  );
}

export default FlexiGridAutoComplete;


// //SEARCHINPUT VERSION:
// <Autocomplete
// 						value={searchpairstate.value}
// 						//Try without! Works great! inputValue={searchpairstate.inputValue}
// 						style={{ flexGrow: 1 }}
// 						//forcePopupIcon={false}
// 						//clearOnBlur={false}
// 						freeSolo
// 						disableCloseOnSelect
// 						//multiple={searchpairstate.multiple}
// 						multiple //Maybe leave this here and if we need limit, do it through a new prop. SearchTools counts on this for arrays.
// 						className={classes.searchinputautocomplete}
// 						open={openoptions} onOpen={() => { InitItemOptions(); }} onClose={() => onCloseHandler()}
// 						//Not sure how to avoid passing event, then newvalue... seems to break when removing event.
// 						onChange={(event, newValue) => onChangeItemOption(event, newValue)}
// 						onInputChange={(event, value, reason) => {
// 							onChangeAutoCompleteInput(event.target.value, reason);
// 						}}
// 						isOptionEqualToValue={(option, value) => {
// 							//console.log(option[keyedby]);
// 							//console.log(value[keyedby]);
// 							if (option[searchpairstate.keyedby] === value[searchpairstate.keyedby]) {
// 								return true;
// 							}
// 						}}
// 						getOptionLabel={(option) => option[searchpairstate.searchkey]} //This may be the thing that is sent to isOptionEqualToValue....

// 						renderTags={(value, getTagProps) =>
// 							value.map((option, index) => {
// 								const { key, ...rest } = getTagProps({ index });
// 								//console.log(option);
// 								return (
// 									<Chip 
// 										sx={{
// 											margin: "0px",
// 											backgroundColor: '#e0ecf9',
// 											padding: "0px",
// 											'.MuiSvgIcon-root': {
// 												color: '#588dc9', // Change icon color on focus
// 												'&: hover': {
// 													color:"#01579B"
// 												},
// 											},
// 											'& .MuiChip-label': {
// 												padding: '2px 7px 0px 7px',  // Optional: Adjust label padding
// 											},
// 											'&:focus': {
// 												backgroundColor: '#2266b5',
// 												color:"#FFF",
// 												'.MuiSvgIcon-root': {
// 													color: '#FFF', // Change icon color on focus
// 												},
// 											},
// 										}}
// 										clickable
// 										key={option[searchpairstate.keyedby]}
// 										size="small"
// 										variant="standard"
// 										label={option[searchpairstate.searchkey]}
// 										{...rest}
// 										onClick={handleChipClick}
// 										tabIndex={0}
// 									/>
// 								);
// 							})
// 						}

// 						options={itemoptions}
// 						loading={loadingitemoptions}

// 						renderInput={(params) => (
// 							<Box
// 								ref={params.InputProps.ref}
// 								sx={{
// 									display: "flex",
// 									alignItems: "top",
// 									borderBottom: "1px solid #EEE",
// 									padding: "0px",
// 									margin: "0px",
// 									width: "100%",
// 								}}
// 							>
// 								{params.InputProps.startAdornment} {/* Chips will render here */}
// 								<input
// 									{...params.inputProps}
// 									style={{
// 										border: "none",
// 										outline: "none",
// 										flexGrow: 0,
// 										minWidth: "100px",
// 										margin: "2px 0px 0px 3px"
// 									}}
// 								/>
// 							</Box>
// 						)}



// 						renderOption={(props, option) => (
// 							<ListItem {...props} key={option[searchpairstate.keyedby]}>
// 								{(option.IconURL) &&
// 									<div style={{display:"inline-block", marginRight:"10px"}}><img src={option.IconURL} style={{width:"25px"}} /></div>
// 								}
// 							  <ListItemText primary={option[searchpairstate.searchkey]} secondary={option.iconURL} />
// 							</ListItem>
// 						  )}





// 						placeholder="This"
// 						label="That"
// 						disabled={props.disabled}
// 						filterOptions={(options, params) => {
// 							const filtered = filter(options, params);

// 							if (props.allowadd) {
// 								const { inputValue } = params;
// 								// Suggest the creation of a new value
// 								const isExisting = options.some((option) => inputValue === option[searchpairstate.searchkey]);
// 								if (inputValue !== '' && !isExisting) {
// 									filtered.push({
// 										inputValue,
// 										[props.searchkey]: `Add "${inputValue}"`,
// 										addnewitem: true, //Flag controller, we're creating a new item - possibly set PendingItem for pending db call
// 										newitemvalue: inputValue
// 									});
// 								}
// 							}

// 							return filtered;
// 						}}
// 					/>
// 				}



















//KEYVALUE VERSION:

// return (
// <Autocomplete forcePopupIcon={false} style={{ width: "100%" }}
// 	clearOnBlur
// 	freeSolo={props.freeSolo}
// 	className={(props.grayplaceholder && !defaultsearchterm) ? classes.dbautocompletegray : classes.dbautocompleteblack}
// 	open={openoptions} onOpen={() => { InitItemOptions(); }} onClose={() => onCloseHandler()}
// 	//Not sure how to avoid passing event, then newvalue... seems to break when removing event.
// 	onChange={(event, newValue) => onChangeItemOption(event, newValue)}
// 	onInputChange={(event) => {
// 		console.log(event);
// 			if (event){ //For some reason onInputChange may be firing after a selection with no event value?
// 				ItemSearch(event.target.value)
// 			}
// 		}
// 	}
// 	isOptionEqualToValue={(option, value) => {
// 		//console.log(option[keyedby]);
// 		//console.log(value[keyedby]);
// 		if (option[keyedby] === value[keyedby]){
// 			return true;
// 		} }}
// 	getOptionLabel={(option) => option[props.searchkey]} //This may be the thing that is sent to isOptionEqualToValue....
// 	renderOption={(props, option) => {
// 		//Needs to be list item. We can do all of our customization here possibly:
// 		return (
// 			<li {...props} key={option.ID}>
// 				{(searchtype==="components") &&
// 					<span><b>{option.ProductType}</b> &rarr; <b>{option.ComponentType}</b> &rarr; {option.Name}</span>
// 				}
// 				{(searchtype!=="components") &&
// 					<span>{option[searchkey]}</span>
// 				}
// 			</li>
// 		);
// 	}}
	
// 	options={itemoptions}
// 	loading={loadingitemoptions}
// 	//Setting value or defaultValue kinda breaks this. Use placeholder instead based on a useState variable
// 	//Some AutoCompletes will clear their entry on selection. Add option to pass via props, grayplaceholder. Attempt to format the placeholder as well.
// 	//Otherwise, use defaultsearchterm which is usually a DB value sent from the controller.
// 	renderInput={(params) => (
// 		<div className={classes.hoverunit} style={{ borderBottom: "0px solid #EEE", height: "27px" }}>
// 			{/* A regular <input> can't use inputRef or ref at all really. It simply won't work. */}
// 			<CssTextField
// 				variant="standard"
// 				{...params}
// 				inputRef={inputRef} // This ensures the ref is properly assigned
// 				placeholder={
// 					props.grayplaceholder && !defaultsearchterm
// 						? props.grayplaceholder
// 						: defaultsearchterm
// 				}
// 				InputProps={{
// 					...params.InputProps,
// 					endAdornment: props.endadornment || null,
// 				}}
// 			/>



// 		</div>
// 	)}

// 	placeholder="This"
// 	label="That"
// 	disabled={props.disabled}
// 	filterOptions={(options, params) => {
// 		const filtered = filter(options, params);
		
// 		if (props.allowadd){
// 			const { inputValue } = params;
// 			// Suggest the creation of a new value
// 			const isExisting = options.some((option) => inputValue === option[props.searchkey]);
// 			if (inputValue !== '' && !isExisting) {
// 				filtered.push({
// 					inputValue,
// 					[props.searchkey]: `Add "${inputValue}"`,
// 					ID:uuidv4(), //Helps avoid unique key error when adding to the collection.
// 					addnewitem: true, //Flag controller, we're creating a new item - possibly set PendingItem for pending db call
// 					newitemvalue: inputValue
// 				});
// 			}
// 		}
		
// 		return filtered;
// 	}}
// />
// );